import React, { useEffect } from 'react'
import { Container, Pagination, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchNewsData, fetchNewsPagination } from '../../../redux/action/homePage/news/homeNews'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'
import MainLoading from '../../../utils/MainLoading'
import './style.scss'
import moment from "moment-jalaali";
import renderHTML from 'react-render-html';
import default_image_url from '../../../redux/api/API'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const News = () => {
    const dispatch = useDispatch()
    const newsData = useSelector(state => state.newsData)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        if(!newsData.news.data) {
            dispatch(fetchNewsData())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchNewsPagination(e.target.href))
    }

    return (
        <Wrapper>
            <Helmet>
                <title>اخبار - نمایشگاه مجازی</title>
            </Helmet>
            <Container className="mt-5">
                <HomeMainTitle> {t("dashboard_nav_news")} </HomeMainTitle>
                {newsData.loading ?
                    <MainLoading />
                :
                    newsData.news.data &&
                        newsData.news.data.length ?
                        <>
                            <Row>
                                {newsData.news.data.map(news => (
                                    <div className='col-lg-4 home_items_container' key={news.id}>
                                        <div className='home_item'>
                                            <div className='home_item_image'>
                                                {news.image ?
                                                    <img src={default_image_url+news.image.path} alt="news"/>
                                                :
                                                    <img src='/assets/img/news_icon.png' alt="news"/>
                                                }
                                            </div>
                                            <h1> {news.title} </h1>
                                            <div className='home_item_handle_content'>{renderHTML(news.description)}</div>
                                            <div className='home_item_footer'>
                                                {lang === 'en' ?
                                                    <span>{news.created_at && news.created_at.substr(0, 10)} - {news.created_at.substr(11, 5)}</span>
                                                :
                                                    <span>{moment(news.created_at && news.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')} - {news.created_at.substr(11, 5)}</span>
                                                }
                                                <Link className='btn purple-btn btn-sm px-4' to={`/news/${news.id}`}>{t("view")}</Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Row>

                            <div className='pagination_container mt-5'>
                                <Pagination>
                                    {newsData.news.links ? newsData.news.links.map(link => (
                                        <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                            {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                        </Pagination.Item>
                                    )) : ''}
                                </Pagination>
                            </div>
                        </>
                    :
                        <h6 className='text-center'> خبری ثبت نشده است </h6>
                    }
            </Container>
        </Wrapper>
    )
}

export default News
